import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL || (
  process.env.NODE_ENV === "development"
    ? "http://localhost:3007"
    : "https://api.kanchira.com"
);
const clientApi = axios.create({ baseURL: API_BASE });

clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("clientAdminToken");
  if (token && !config.url?.endsWith("/client/auth/token")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

clientApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("clientAdminToken");
      localStorage.removeItem("clientAdminId");
      if (window.location.pathname.startsWith("/client-admin")) {
        window.location.assign("/client-admin/login");
      }
    }
    return Promise.reject(error);
  },
);

export const loginClientAdmin = ({ clientId, clientPassword }) =>
  clientApi.post("api/v1/client/auth/token", null, {
    headers: {
      client_id: clientId,
      client_secret: clientPassword,
    },
  });

export const lookupClientInvoices = (productId) =>
  clientApi.post("api/v1/client/invoices/lookup", { productId });

export const updateClientInvoice = (productId, updates) =>
  clientApi.patch(`api/v1/client/invoices/product/${encodeURIComponent(productId)}`, updates);
